<template>
  <div class="bg-white p-8">
    <div class="mt-4">
      <div class="relative">
        <el-input
          placeholder="Search"
          v-model="search"
          maxlength="50"
          class="rounded-none w-full"
        ></el-input>
        <div class="absolute top-0 right-0 mt-2 mr-2">
          <feather-icon icon="SearchIcon" class="" />
        </div>
      </div>
    </div>
    <div class="mt-4">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
        header-row-class-name="thead-light table-th-color"
      >
        <el-table-column
          :index="indexmethod"
          type="index"
          label="Sr.no"
          width="80"
        ></el-table-column>
        <el-table-column
          prop="reviewImage"
          label="Product Image"
          min-width="50px"
        >
          <template v-slot="{ row }">
            <img
              v-if="row.reviewImage.length <= 0"
              src="@/assets/images/icons/coupon management.svg"
              class="w-full"
            />
            <!-- <img
              v-else
              :src="
                row.reviewImage[0]
                  ? getImage(row.reviewImage[0])
                  : require('@/assets/images/icons/coupon management.svg')
              "
              class="w-full"
            /> -->
            <swiper :options="planswiperOption" class="swip" v-else>
              <swiper-slide
                class="m-2 cursor-pointer rounded-12px"
                v-for="(reviewImage, index) in row.reviewImage"
                :key="index"
              >
                <img
                  :src="getImage(reviewImage)"
                  alt="review Image"
                  class="w-full"
                />
              </swiper-slide>
              <div
                class="swiper-button-prev cust-swipsizel"
                slot="button-prev"
              ></div>
              <div
                class="swiper-button-next cust-swipsize"
                slot="button-next"
              ></div>
            </swiper>
          </template>
        </el-table-column>
        <el-table-column
          prop="productId.productName"
          label="Product"
          min-width="50px"
        >
          <template v-slot="{ row }">
            <P class="text-gray fsize12">{{ row.productId[0].productName }}</P>
          </template>
        </el-table-column>
        <el-table-column prop="userId" label=" Name" min-width="50px">
          <template v-slot="{ row }">
            <P class="text-gray">
              {{ row.userId[0].firstName }} {{ row.userId[0].lastName }}
            </P>
          </template>
        </el-table-column>

        <el-table-column prop="description" label="Review" min-width="50px">
          <template v-slot="{ row }">
            <div>
              <P class="text-gray fsize12">{{ row.description }} </P>
              <el-rate
                v-model="row.rating"
                disabled
                show-score
                class="mt-2"
                text-color="#ff9900"
                :score-template="`${row.rating} points`"
              >
              </el-rate>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="Status" label="Status" min-width="40px">
          <template v-slot="{ row }">
            <div
              class="flex gap-2 items-center"
              v-if="row.status === 'pending'"
            >
              <p
                class="bg-fas w-12 h-12 rounded-full cursor-pointer flex items-center justify-center"
              >
                <feather-icon
                  svgClasses="w-4 h-4"
                  icon="CheckIcon"
                  @click="handleEdit(row, 'approved')"
                />
              </p>
              <p
                class="bg-fas w-12 h-12 rounded-full flex cursor-pointer items-center justify-center"
              >
                <feather-icon
                  svgClasses="w-4 h-4"
                  icon="XIcon"
                  @click="handleEdit(row, 'rejected')"
                />
              </p>
            </div>
            <div v-else>
              <p
                :class="`text-${
                  row.status === 'approved' ? 'success' : 'danger'
                } rounded-full cursor-pointer px-4 py-1 fsize12`"
              >
                {{ row.status === "approved" ? "Approved" : "Rejected" }}
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="city" label="Actions" min-width="40px">
          <template v-slot="{ row }">
            <div class="flex gap-2 items-center" @click="deletePopup(row)">
              <p
                class="bg-lighty text-danger rounded-full cursor-pointer px-4 py-1 fsize12"
              >
                Delete
              </p>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="w-full flex justify-end mt-6">
      <el-pagination
        background
        layout="prev,pager,next"
        :total="totalRows"
        :page-size="perPage"
        @current-change="setPage"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

const debounce = (fn, ms = 0) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};

export default {
  data() {
    return {
      totalRows: 0,
      perPage: 10,
      currentPage: 1,

      search: "",
      tableData: [
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
      ],
      planswiperOption: {
        slidesPerView: 1.1,
        observer: true,
        observeParents: true,
        spaceBetween: 25,
        breakpoints: {
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          575: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          425: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
  computed: {
    ...mapState("admin", ["login"]),
    ...mapState("user", {
      selectedProject: "selectedProject",
    }),
    ...mapState("EcomReview", {
      review: "review",
    }),
  },
  watch: {
    async currentPage() {
      await this.getReview();
    },
    search: {
      handler: debounce(async function (val) {
        this.currentPage = 1;
        this.getReview();
      }, 500),
    },
  },
  methods: {
    // debounce(fun, ms = 0) {
    //   let timeoutId;
    //   return function (...args) {
    //     clearTimeout(timeoutId);
    //     timeoutId = setTimeout(() => fun.apply(this, args), ms);
    //   };
    // },
    getImage(img) {
      return `${this.$imageURL}/${img}`;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    indexmethod(index) {
      if (this.currentPage > 1) {
        let value = (this.currentPage - 1) * 10;
        return index + value + 1;
      } else {
        return index + 1;
      }
    },
    async handleEdit(review, status) {
      const payload = new FormData();
      payload.append("adminId", this.login._id);
      payload.append("reviewId", review._id);
      payload.append("status", status);

      let loader;
      try {
        // console.log(payload);
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        const updateReview = await this.$store.dispatch(
          "EcomReview/updateReview",
          payload
        );

        if (updateReview.code === 200) {
          loader.close();
          this.handleClose();
          await this.$swal({
            title: `Review ${status}!`,
            type: status === "approved" ? "success" : "error",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
          this.getReview();
        }
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    async deletePopup(row) {
      this.$swal({
        title: "Are you sure?",
        type: "Warning",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#cd3197",
        confirmButtonText: "Yes, Delete it",
        cancelButtonText: "No, keep it",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.$swal("Deleted", "Review Deleted Successfully!", "success");
          this.handleDelete(row._id);
        }
      });
    },
    async handleDelete(reviewId) {
      let payload = {
        reviewId: reviewId,
        adminId: this.login._id,
      };
      let data = await this.$store.dispatch("EcomReview/deleteReview", payload);
      this.currentPage = 1;
      this.getReview();
    },
    // async handleAddCoupon() {
    //   const payload = new FormData();
    //   payload.append("couponName", this.name);
    //   payload.append("description", this.description);
    //   payload.append("couponCode", this.code);
    //   payload.append("discountPercentage", this.discountPercentage);
    //   payload.append("discountLimit", this.discountLimit);
    //   payload.append("minimumAmountPurhcase", this.minimumPurchase);
    //   payload.append("usageLimit", this.usageLimit);
    //   payload.append("startDate", this.startDate);
    //   payload.append("expiryDate", this.endDate);
    //   payload.append("adminId", this.login._id);

    //   let loader;
    //   try {
    //     console.log(payload);
    //     loader = this.$loading({
    //       lock: true,
    //       text: "Loading",
    //       spinner: "el-icon-loading",
    //       background: "rgba(0, 0, 0, 0.7)",
    //     });
    //     const createCoupon = await this.$store.dispatch(
    //       "EcomCoupon/addCoupon",
    //       payload
    //     );

    //     if (createCoupon.code === 200) {
    //       // console.log(createCoupon);
    //       loader.close();
    //       this.handleClose();
    //       await this.$swal({
    //         title: "Coupon Created Successfully!",
    //         type: "success",
    //         showCancelButton: false,
    //         confirmButtonColor: "#830c81",
    //       });

    //       this.name = "";
    //       this.description = "";
    //       this.code = "";
    //       this.discountPercentage = "";
    //       this.discountLimit = "";
    //       this.minimumPurchase = "";
    //       this.usageLimit = "";
    //       this.startDate = null;
    //       this.endDate = null;
    //       this.getCoupon();
    //       // console.log(this.testimonial);
    //     }
    //     loader.close();
    //   } catch (error) {
    //     loader.close();
    //     console.log(error);
    //   }
    // },
    async getReview() {
      let curPage = this.currentPage - 1;
      let payload = {
        limit: this.perPage,
        offset: curPage,
      };
      let loader;

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      try {
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        const getReview = await this.$store.dispatch(
          "EcomReview/getReview",
          payload
        );
        // console.log(getCoupon);
        loader.close();
        if (getReview.code === 200) {
          this.totalRows = this.review.totalCount;
          this.tableData = this.review.result;
        }
      } catch (error) {
        loader.close();
      }
    },
    handleClose() {
      this.isShowCoupon = false;
    },
    setPage(page) {
      this.currentPage = page;
    },
  },
  async mounted() {
    await this.getReview();
  },
};
</script>
<style>
.swip .swiper-button-next {
  color: #cd3197 !important;
}
.swip .swiper-button-prev {
  color: #cd3197 !important;
}
</style>
